import { render } from "./EditItem.vue?vue&type=template&id=83c3edf2&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"

import "./EditItem.vue?vue&type=style&index=0&id=83c3edf2&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c3edf2"]])

export default __exports__